import { dolarDoReal, type PromocaoNaVitrine, type Vitrine } from "@mtc/contratos";
import { formatarDolares, formatarReais } from "@mtc/ui";

/**
 * O desconto que o destaque e o selo da promocao anunciam (spec 067): "30%" ou o valor fixo, que vem na moeda da vitrine
 * (dolar no checkout anunciado em dolar, real nos outros: 2.1). E so o anuncio; o que a compra tira e o
 * `desconto_centavos`, que o servidor calculou.
 */
export function descontoAnunciado(p: Pick<PromocaoNaVitrine, "tipo" | "percentual" | "valor_centavos" | "desconto_centavos">, v: Pick<Vitrine, "anunciado_em_dolar">): string {
  const d = v.anunciado_em_dolar;
  if (p.tipo === "PERCENTUAL" && p.percentual) return `${p.percentual}%`;
  if (p.valor_centavos) return d ? formatarDolares(p.valor_centavos) : formatarReais(p.valor_centavos);
  return d ? formatarDolares(dolarDoReal(p.desconto_centavos, d.cotacao)) : formatarReais(p.desconto_centavos);
}
